/**
 * @description Generic client-side text search across a record's own fields.
 * The Users / Content Items / Audit Log endpoints return full, unpaginated
 * lists (see the UAM CMS Backend Postman collection), so table filtering
 * happens in the browser rather than via server query params.
 */
export const matchesSearch = <T extends Record<string, any>>(record: T, fields: (keyof T)[], search: string): boolean => {
  if (!search) return true;
  const needle = search.toLowerCase();
  return fields.some((field) => String(record[field] ?? '').toLowerCase().includes(needle));
};

export const matchesFilters = <T extends Record<string, any>>(record: T, filters: Partial<Record<keyof T, string>>): boolean => {
  return Object.entries(filters).every(([key, value]) => {
    if (value === undefined || value === null || value === '') return true;
    return String(record[key as keyof T] ?? '') === String(value);
  });
};
